import { render, staticRenderFns } from "./StudentListReport.vue?vue&type=template&id=70c5247e&scoped=true"
import script from "./StudentListReport.vue?vue&type=script&lang=js"
export * from "./StudentListReport.vue?vue&type=script&lang=js"
import style0 from "./StudentListReport.vue?vue&type=style&index=0&id=70c5247e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c5247e",
  null
  
)

export default component.exports